<app-dashboard-element icon="calories" title="dashboard.weekly_trends.title"
    description="dashboard.weekly_trends.description">

    <table>
        <thead>
            <tr>
                <th scope="col">#</th>
                <th scope="col">{{ 'dashboard.weekly_trends.keyword' | translate }}</th>
                <th scope="col">{{ 'dashboard.weekly_trends.search' | translate }}</th>
            </tr>
        </thead>
        <tbody>
            @for(trendItem of trends(); track $index ){
            <tr>
                <th scope="row" class="index">{{$index + 1}}</th>
                <th>
                    <div class="word-element">
                        <div class="position-icon" [class]="trendItem.position">
                            @switch (trendItem.position) {
                            @case ('up') {▲}
                            @case ('down') {▼}
                            @default {
                            <div class="equal">
                                <span></span>
                                <span></span>
                            </div>
                            }
                            }
                        </div>
                        <p>{{trendItem.word}}</p>
                    </div>
                </th>
                <th class="search-count">{{trendItem.searchCount}}</th>
            </tr>
            }
        </tbody>
    </table>

</app-dashboard-element>